import script from "./entryPages.vue?vue&type=script&lang=ts&setup=true"
export * from "./entryPages.vue?vue&type=script&lang=ts&setup=true"

import "./entryPages.vue?vue&type=style&index=0&id=22818264&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22818264"]])

export default __exports__